var _circle, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    fill: "#2B234A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_129_24",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_129_24",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFb0lEQVR4nO2da4hVVRTHdy9NjCBIjCjs8aUHYS96SjVZFBWlRUoWmI01pZkfIpA+1FVKelE0MEJfIyI/9IZelhVNhT2hBxFUVqCFY2NGZerUL1Z3EXE7e99z7sw5e5999u/TMMyw1153P/5777XWNSaRSCQSiUQikUgkEvkA9gKOBwaAB4BngM+A74BRYDewU3/+GvgEeBq4B7gOOAHYM2dzzQI4CFgKvAhsZ/z8BDwFLAGmmyYD7AMsANYDY5SHzIDngSuBSaYpAPsDtwObqJ5vdZTvayIfwUuBLfhnM3B9dGs5cAbwBeHxrmy8pu7IFAXu72EN/gV4GVgFXAOcBswADtCZMUl/PgI4FVgIrNb/+a2HNXylqJ0ufWkB00xoqGM+KtDh74EHgdO7dbpLu/IhnAU8XHCZek3Uj8PJwjkmJLSjeTv5KnBJGeuljv65wDs5bfkBOMniZGGJCQXgcj1QdOMN4OQK7Zqd0+GybM3OcLIwZEJAdbGseS42AXM82bcH0A9s7WLjH8DajN+/7sPuzk7My7HpPSabWAC2TgNeoDhbfBt+JrDDYeAu4EYTEDq6V+SYgZ34UR4qsUYchm0DzjaBAlwG/F7A0dUrD93VNziMkg/gRBM4qpJcMxKvykOvJl0j+ThTA/i/unAx5ONY/adjTf5HIkXm5GqVh17Of4idAROnk6tVHsBN2HnSxOvk6pQHMAX4EfthxLtOLtnJ1SgP4BaHAQtM/E4uX3nozZjcsmXxlhwCTOAABwJ9uvyt0ac01zmgeuUBXOFoPNhDSR70fnsWcINesa7Tl5jqlQfwnG00m0ghewZ8XmaD01UfZzG3tIabhl4vZrG1Uc/4ZQM8YXH0YOmNNwV5ZnLszOf7ti8agGMsTpbrxSm+7YsGYL7F0et92xYVwN0WRz/k27ambIT9vm2LChXqWcz0bVtUAMcCv3Y4+SXfdkWJRtKv1SAUiYmb6tumRCKRqAHAZOBW4Fm9Sj3Mt01RQjv7qzMp6RDfdkUFcLRF4t7r27aoABZbHP2ob9uiAhi0OHqVb9uiAnjT4uh5vm2LBmCqBqdncZRv+6IBuMji5JHochUDvVR73KthMUE7aMiW87LQt33RQDs3J4udEx7sCHwJDAOPAMuB84CDTQMA3q4salZzArMYjfkDoJ2baOPSMhocohgjGjq1RkOp+iS0ytQIzdqyjeaNwN5lNCrlH8bLnaZGANc6+lJOKp8EXo/TyS1Tv8BGW7D95tIKq2imaSNGsqAFs2wsNmXSY+WYWo1kAbjZ0Z8NpZ8EJfi6oJNrd2oCLnCkLI9VUo2hB+UhlzAXmnq98m939GdlVYZIda2iSBBknwkcGan6LGVjuBQ5N8HKYwdwlQkU1fg/O+wX9TGjSoO6KQ9b2oXwF3BHaFlbwLIuZSSkENYpPgyzKQ/J3Ts3RzmGV4BDKzc8WydnVZjp3Py8VMqxKY9/JZxE/+cox7ANWOTrwlxLZ9oOI/+dnf6eqDKUR8sikaQAVDc+lr+tuBqD7e6i8/rTz0i2KA/rYUTqdADfkI9h4GqJAiop92aO4/axExnpsybajvEoj1bOzdP2cmy78RvUGdHzXYLIMK0oM1iw0Oz7wUQdqfNaBet6rHC8ILt2+3VaqLtfp/2R2v5kLTEkKcWHa+EsKZl5l1Zj7Izj7sZuTR2Z8BnlK5D9PcLjUy/yrUxor5ey43/l27u6TC2v7LTn8VV5mdbsrxpp8zZgP9MUaK/fF2uscZml58d0vZ8f9Qgu8GUKizTNznW5k5dRres/EGTN54BG+kwtKLtaXzs+0K8CGVEFs0uduVG/HkS+oeI+LScvGj6FaSUSiUQikUgkEomEycnf4D0GwIDCkz4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRetry);
export default __webpack_public_path__ + "static/media/ic_retry.4a093aa8b4e7eca69ded5e0b791787b9.svg";
export { ForwardRef as ReactComponent };